<template>
  <div>
    <div class="vg-content">
      <div class="head" v-if="isSuccess !== undefined">
        <van-image width="40" height="40" :src="isSuccess?srcSuccess:srcFailed"/>
        <div class="result" :style="isSuccess?'color:#4BA9F6':'color:#DC3C27'">{{ strResult }}</div>
      </div>
      <vg-card v-if="isSuccess !== undefined && isError" class="error">{{ errorMessage }}</vg-card>
      <vg-card v-if="isSuccess !== undefined && !isError" class="status"
               :class="{success: isSuccess, failure: isExpired, notstarted: isNotStarted}">
        <div class="vg-detail">
          <div class="item">
            <div class="item-entry" style="margin-top: 0px;">
              <div class="item-title">验真时间：</div>
              <div class="item-text">{{ details.verifyTime }}</div>
            </div>
            <div class="item-entry">
              <div class="item-title">项目：</div>
              <div class="item-text">{{ details.projectName }}</div>
            </div>
            <div class="item-entry">
              <div class="item-title">品牌名称：</div>
              <div class="item-text" style="font-weight: bold;">{{ details.brandName }}</div>
            </div>
            <div class="item-entry">
              <div class="item-title">商铺号：</div>
              <div class="item-text">{{ details.storeCode }}</div>
            </div>
            <div class="item-entry">
              <div class="item-title">申请人：</div>
              <div class="item-text">{{ details.realName }}</div>
            </div>
            <div class="item-entry">
              <div class="item-title">手机号：</div>
              <div class="item-text">{{ details.mobileNo }}</div>
            </div>
          </div>

          <div class="item" style="margin-top: 10px;">
            <div class="item-entry" style="margin-top: 0px;">
              <div class="item-title">申请事项：</div>
              <div class="item-text" style="font-weight: bold;">{{ getActionType(details.actionTypeDesc) }}</div>
            </div>
            <div class="item-entry">
              <div class="item-title">审核人：</div>
              <div class="item-text">{{ details.approveUserName }}</div>
            </div>
            <div class="item-entry">
              <div class="item-title">货品种类：</div>
              <div class="item-text" style="font-weight: bold;">{{ details.category }}</div>
            </div>
            <div class="item-entry">
              <div class="item-title">开始时间：</div>
              <div class="item-text">{{ details.startDate }}</div>
            </div>
            <div class="item-entry">
              <div class="item-title">结束时间：</div>
              <div class="item-text">{{ details.endDate }}</div>
            </div>
            <div class="item-entry">
              <div class="item-title">流程备注：</div>
              <div class="item-text">{{ details.remark }}</div>
            </div>
            <div class="item-entry">
              <div class="item-title">数量：</div>
              <div class="item-text">{{ details.number }}</div>
            </div>
            <div class="item-entry">
              <div class="item-title">现场负责人：</div>
              <div class="item-text">{{ details.director }}</div>
            </div>
            <div class="item-entry">
              <div class="item-title">联系方式：</div>
              <div class="item-text">{{ details.telephone }}</div>
            </div>
            <div class="item-entry" v-if="!isSuccess">
              <div class="item-title">失败原因：</div>
              <div class="item-text">{{ getErrorStr(details.verifyResult) }}</div>
            </div>
            <div class="item-entry" style="margin-top: 30px;">
              <div class="item-title">上传附件：</div>
              <vg-image-uploader disabled :file-list="imageFiles"/>
            </div>
            <div class="item-link" v-for="(item,index) in otherFiles" :key="index">
              <van-image class="link-type" :src="srcPdf"/>
              <div class="link-url" @click="toLink(item.url)">{{ item.url }}</div>
            </div>
          </div>
        </div>
      </vg-card>
    </div>

    <vg-button-group>
      <vg-button type="primary" @click="onSubmit">继续验真</vg-button>
    </vg-button-group>
  </div>
</template>

<script>
import VgButton from "@/components/Commons/VgButton";
import VgButtonGroup from "@/components/Commons/VgButtonGroupFixed.vue";
import {Image as VanImage} from "vant";
import srcSuccess from "@/assets/scanverify/success.svg";
import srcFailed from "@/assets/scanverify/failed.svg";
import srcPass from "@/assets/scanverify/pass.png";
import srcExpired from "@/assets/scanverify/expired.png";
import srcNotStarted from "@/assets/scanverify/notstarted.png";
import VgCard from "@/components/Commons/VgCard.vue";
import srcPdf from "@/assets/scanverify/pdf.svg";
import VgImageUploader from "@/components/Commons/VgImageUploader";
import {client} from "@/libraries/http";

export default {
  name: "VerifyGoodsInOutResult",
  components: {
    VgCard,
    VgButton, VgButtonGroup, VanImage,
    VgImageUploader,
  },
  data() {
    return {
      srcSuccess: srcSuccess,
      srcFailed: srcFailed,
      srcPass: srcPass,
      srcExpired: srcExpired,
      srcPdf: srcPdf,
      srcNotStarted: srcNotStarted,
      isSuccess: undefined,
      strResult: "验真成功",
      isError: false,
      errorMessage: "",
      id: "",
      message: undefined,
      details: {},
    }
  },
  mounted() {
    console.log(this.$route);
    this.id = this.$route.query.id;
    this.message = this.$route.query.message;
    if (this.message) {
      this.isError = true;
      this.errorMessage = this.message;
      this.isSuccess = false;
      this.strResult = "验真失败";
    } else {
      this.detail();
    }
  },
  computed: {
    imageFiles() {
      return this.details?.attachments.filter(att => att.type === 'IMG');
    },
    otherFiles() {
      return this.details?.attachments.filter(att => att.type !== 'IMG');
    },
    isExpired() {
      return this.details?.verifyResult === 'EXPIRED';
    },
    isNotStarted() {
      return this.details?.verifyResult === 'NOT_STARTED';
    },
  },
  methods: {
    onSubmit() {
      this.$router.replace({path: '/scanVerify/richScan'});
    },
    detail() {
      client.get("/api/h5/guard/verify/goods/detail/" + this.id).then(res => {
        console.log(res);
        this.isSuccess = res.data.verifyResult === "PASS";
        this.strResult = this.isSuccess ? "验真成功" : "验真失败";
        if (res.data.verifyResult === 'COUNT_LIMIT') {
          this.isError = true;
          this.errorMessage = "该货品进出二维码已达使用次数上限，请勿重复使用";
        } else if (res.data.verifyResult === 'DIFF_PROJECT') {
          this.isError = true;
          this.errorMessage = "无效二维码，货品进出二维码所属项目与当前扫码验真项目不一致，请切换项目后重试";
        } else {
          this.isError = false;
          this.details = res.data;
        }
      }).catch(error => {
        console.log(error);
        this.isError = true;
        this.errorMessage = error.response.data?.message;
        this.isSuccess = false;
        this.strResult = "验真失败";
      })
    },
    getActionType(type) {
      if (type === 'OUT') {
        return '出货';
      } else if (type === 'IN') {
        return '进货';
      }
    },
    getErrorStr(result) {
      if (result === 'DIFF_PROJECT') {
        return '无效二维码，货品进出二维码所属项目与当前扫码验真项目不一致';
      } else if (result === 'COUNT_LIMIT') {
        return '该货品进出二维码已达使用次数上限';
      } else if (result === 'EXPIRED') {
        return '货品进出二维码已过期';
      } else if (result === 'NOT_STARTED') {
        return '货品进出二维码未到开始时间';
      }
    },
    toLink(url) {
      window.open(url, '_blank');
    },
  },
}
</script>

<style scoped>
.vg-content {
  /*margin: 15px;*/
  display: flex;
  flex-direction: column;
}

.head {
  margin-top: 20px;
  display: flex;
  align-items: center;
  align-self: center;
}

.result {
  margin-left: 15px;
  font-size: 26px;
  color: #4BA9F6;
}

.status:before {
  content: "";
  opacity: 0.7;
  position: absolute;
  right: 20px;
  top: 160px;
  width: 22vw;
  height: 16.5vw;
  background-size: contain;
  background-repeat: no-repeat;
}

.status.success:before {
  background-image: url("@/assets/scanverify/pass.png");
}

.status.failure:before {
  background-image: url("@/assets/scanverify/expired.png");
}

.status.notstarted:before {
  background-image: url("@/assets/scanverify/notstarted.png");
}

.error {
  margin-top: 30px;
  width: auto;
  padding: 15px;
  border-radius: 5px;
  border: 1px solid #EDEBED;
  color: #101010;
  font-size: 16px;
  text-align: left;
}

.vg-detail {
  /*margin: 20px 15px;*/
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #EDEBED;
  background: #FFFFFF;
}

.item {
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #EDEBED;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.item-entry {
  margin-top: 13px;
  display: flex;
  align-items: flex-start;
}

.item-title {
  min-width: 95px;
  font-size: 16px;
  color: #B4B4B4;
}

.item-text {
  font-size: 16px;
  color: #000000;
}

.item-link {
  margin-left: 95px;
  margin-top: 10px;
  display: flex;
  align-items: flex-start;
}

.link-type {
  width: 15px;
  height: 15px;
  flex-shrink: 0;
}

.link-url {
  margin-left: 5px;
  font-size: 12px;
  color: #2897FF;
  word-break: break-all;
}

</style>
